/*
 * Copyright (C) 2005 - 2022 TIBCO Software Inc. All rights reserved. Confidentiality & Proprietary.
 * Licensed pursuant to commercial TIBCO End User License Agreement.
 */

import _ from "underscore";

function extractParameters(url) {
    let questionIdx;
    let hashIdx;
    let
        res = '';
    if ((questionIdx = url.indexOf('?')) >= 0) {
        if ((hashIdx = url.indexOf('#')) >= questionIdx) {
            res = url.substring(questionIdx + 1, hashIdx);
        } else {
            res = url.substring(questionIdx + 1);
        }
    }
    return res;
}

function parseParameters(paramStr) {
    return paramStr ? _.compact(_.map(paramStr.split('&'), (param) => {
        if (param) {
            const vals = param.split('=');
            return {
                name: vals[0],
                value: vals[1],
            };
        }
    })) : [];
}

function concatParameters(parameters) {
    return _.map(parameters, (param) => {
        if (_.isUndefined(param.value)) {
            return param.name;
        }
        return param.name.concat('=', param.value);
    }).join('&');
}

function setParameterValue(parameters, name, value) {
    for (let i = 0; i < parameters.length; i++) {
        if (parameters[i].name === name) {
            parameters[i].value = value;
            return parameters;
        }
    }
    parameters.push({
        name,
        value,
    });
    return parameters;
}

export default {
    getUrlParameter: (url, name) => {
        return _.find(parseParameters(extractParameters(url)), (parameter) => parameter.name === name);
    },
    setUrlParameter: (url, parameter, value) => {
        let result;
        const questionIdx = url.indexOf('?');
        const hashIdx = url.indexOf('#');
        const
            parameters = concatParameters(setParameterValue(parseParameters(extractParameters(url)), parameter, value));
        if (questionIdx === -1) {
            if (hashIdx === -1) {
                result = url.concat('?', parameters);
            } else {
                result = url.slice(0, hashIdx).concat('?', parameters, url.slice(hashIdx));
            }
        } else if (hashIdx === -1) {
            result = url.slice(0, questionIdx + 1).concat(parameters);
        } else {
            result = url.slice(0, questionIdx + 1).concat(parameters, url.slice(hashIdx));
        }
        return result;
    },
}